
$('.slider-Test').slick({
   autoplay: true,
  autoplaySpeed: 5000,
  infinite: true,
prevArrow:'<div class="arrow_left"></div>',
nextArrow:'<div class="arrow_right"></div>',
});

$('.slider_content').slick({
  autoplay: true,
  autoplaySpeed: 5000,
   dots: true,
  infinite: true,
 prevArrow: '<div class="arrow_left"><svg width="16" height="26" viewBox="0 0 16 26" fill="none"><path d="M5.656 13L15.556 22.9L12.728 25.728L0 13L12.728 0.271999L15.556 3.1L5.656 13Z" fill="#417512"/></svg></i></div>',
 nextArrow: '<div class="arrow_right"><svg width="16" height="26" viewBox="0 0 16 26" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.3441 13L0.444092 3.1L3.27209 0.271999L16.0001 13L3.27209 25.728L0.444092 22.9L10.3441 13Z" fill="#417512"/></svg></div>'

});
$("button").click(function(){
$(".email-dist").fadeOut();
});

$(".crossbtn").click(function()
  {
  $(".announce_ment").fadeOut();
  }
);



  